/**
 *
 * zh-tw
 *
 * Taiwanese Mandarin locale labels
 */

export const Strings = {
  SELECTED_PRODUCTS: "項商品",
  JUST_ADDED_MSGS: "已加入您的購物車​",
  VIEW_CART: "查看購物車​",
  BUNDLE: "精選組合",
  SELF: "(本人)",
  PAY: "支付",
  POINTS: "積點​",
  SETS_OF: " 組 ",
  SET_OF: " 組 ",
};
